<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Sửa điểm danh
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="py-6">
        <div class="mb-3">
          * Sau khi cập nhật điểm danh thành công, thông báo sẽ được gửi đến Phụ huynh (gửi theo Tự động theo đăng ký trong Sổ liên lạc)
        </div>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <DateIOSPicker
                label="Ngày"
                :date.sync="datetime"
                outlined
                class="required"
                :rules="[$rules.required, $rules.date, $rules.dateFromNow]"
                dense
                disabled
                readonly
              />
            </v-col>
            <v-col cols="6">
              <CardStudentName :student="selectedAttendance.student" />
            </v-col>
            <v-col cols="6" class="d-flex justify-space-between align-center">
              <div>
                <p class="text-caption my-0">Ngày sinh</p>
                <span>{{ $_get(selectedAttendance, 'student.dob', '') | ddmmyyyy }}</span>
              </div>
              <div>
                <p class="text-caption my-0">Mã số</p>
                <span>{{ $_get(selectedAttendance, 'student.code', '') | getStudentCode }}</span>
              </div>
              <div>
                <p class="text-caption my-0">Lớp</p>
                <span>{{ $_get(selectedAttendance, 'class.title', '') }}</span>
              </div>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="selectedBoardingClass"
                :items="classList"
                item-text="name"
                item-value="_id"
                label="Lớp bán trú"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12">
              <div class="d-flex justify-center">
                <v-btn :outlined="status !== 'attendance'" class="mr-2" color="success" @click="onAttend">Có mặt</v-btn>
                <v-btn :outlined="status !== 'absent'" color="warning" @click="onAbsent">Vắng mặt</v-btn>
                <div v-if="status === 'absent'" class="ml-2">
                  <v-btn :outlined="subStatus !== 'excused'" class="mr-2" color="success" @click="onExcused">Có phép</v-btn>
                  <v-btn :outlined="subStatus !== 'unexcused'" color="warning" @click="onUnexcused">Không phép</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'

export default {
  components: {
    DateIOSPicker,
    CardStudentName,
  },
  props: {
    state: Boolean,
    selectedAttendance: Object,
  },
  data() {
    return {
      dialog: false,
      datetime: moment().toISOString(),
      selectedBoardingClass: null,
      classList: [],
      status: 'attendance',
      subStatus: 'none',
    }
  },
  computed: {
    ...mapState('boardingClassAttendance', ['date']),
    ...mapState('boardingClass', ['boardingClass']),
  },
  watch: {
    state(val) {
      this.dialog = val
    },
    dialog(newVal) {
      if (!newVal) {
        this.reset()
      } else {
        this.initDataFromSelected()
      }
    },
  },
  mounted() {
    this.loadClassList()
  },
  methods: {
    ...mapActions('boardingClass', ['fetchBoardingClass']),
    ...mapActions('boardingClassAttendance', ['updateAttendance']),

    async loadClassList() {
      try {
        await this.fetchBoardingClass()
        this.classList = this.boardingClass || []
      } catch (error) {
        console.error('Failed to load class list:', error)
      }
    },

    initDataFromSelected() {
      if (this.selectedAttendance) {
        this.status = this.selectedAttendance.status || 'attendance'
        this.subStatus = this.selectedAttendance.subStatus || 'none'
        this.selectedBoardingClass = this.selectedAttendance.boardingClass || null
        this.datetime = this.selectedAttendance.date || moment().toISOString()
      }
    },

    onAttend() {
      this.status = 'attendance'
      this.subStatus = 'none'
    },
    onAbsent() {
      this.status = 'absent'
      this.subStatus = 'unexcused'
    },
    onExcused() {
      this.subStatus = 'excused'
    },
    onUnexcused() {
      this.subStatus = 'unexcused'
    },

    async save() {
      if (!this.$refs.form.validate()) return
      try {
        this.$loading.active = true
        await this.updateAttendance({
          id: this.selectedAttendance.id,
          status: this.status,
          subStatus: this.subStatus,
          date: this.datetime,
          boardingClass: this.selectedBoardingClass,
        })
        this.$alert.updateSuccess()
        this.dialog = false
      } catch (error) {
        console.error(error)
        this.$alert.updateError()
      } finally {
        this.$loading.active = false
      }
    },

    cancel() {
      this.dialog = false
    },

    reset() {
      this.datetime = moment().toISOString()
      this.selectedBoardingClass = null
      this.status = 'attendance'
      this.subStatus = 'none'
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
  },
}
</script>
